import { connect } from 'react-redux';
import { Field, SubmissionError, reduxForm } from 'redux-form';

import { notify } from '@/actions/ui';
import { TextField } from '@/components/FormAdapters';
import { reportProfileSaveFailure } from '@/profile/profileSaveFailure';
import { updateProfile } from '@/profile/store';
import { isValidLinkedin } from '@/utils/reducer';

const SAVE_ERROR = 'An error occurred when updating your LinkedIn URL.';

function validate(values = {}) {
  const errors = {};

  // @ts-expect-error TS(2339): Property 'linkedin_url' does not exist on type '{}... Remove this comment to see the full error message
  if (!isValidLinkedin(values.linkedin_url)) {
    // @ts-expect-error TS(2339): Property 'linkedin_url' does not exist on type '{}... Remove this comment to see the full error message
    errors.linkedin_url = 'Must be a valid https://linkedin.com URL';
  }

  return errors;
}

export function LinkedinForm({
  component: Container,
  reset,
  onReset,
  profileId,
  updateProfile,
  notify,
  onSubmit,
  handleSubmit: handleSubmitProp,
  ...other
}: any) {
  const handleSubmit = async (values: any) => {
    try {
      await updateProfile({ id: profileId, ...values });
    } catch (err) {
      // SubmissionError, not a raw Error: redux-form resolves with its errors, so
      // neither EditDialog nor DeprecatedSaveForm reads the failure as a success.
      throw new SubmissionError({ _error: reportProfileSaveFailure(err, notify, SAVE_ERROR) });
    }

    if (onSubmit) {
      onSubmit(values);
    }
  };

  const handleReset = () => {
    reset();

    if (onReset) {
      onReset();
    }
  };

  return (
    <Container {...other} onSubmit={handleSubmitProp(handleSubmit)} onReset={handleReset}>
      <Field
        fullWidth
        component={TextField}
        name="linkedin_url"
        label="LinkedIn URL"
        inputProps={{ maxLength: 255 }}
      />
    </Container>
  );
}

const WrappedLinkedinForm = reduxForm({
  form: 'expertLinkedin',
  validate,
  enableReinitialize: true,
})(LinkedinForm);

export default connect(
  (state, ownProps) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const profile = state.profiles.fullProfiles[ownProps.profileId];
    return {
      profile,
      initialValues: {
        linkedin_url: profile.linkedin_url,
      },
    };
  },
  {
    updateProfile,
    notify,
  }
)(WrappedLinkedinForm);
